import { useLocation, useParams } from 'react-router-dom';

import RacesOverview from '../../features/races/layouts/overview';
import RaceDetail from '../../features/races/layouts/detail';
import CreateRaceForm from '../../features/races/forms/create';
import EditRaceForm from '../../features/races/forms/edit';

// TSS vite/01 §"Pages are thin".
export default function RacesPage() {
    const { id } = useParams();
    const { pathname } = useLocation();

    if (pathname.endsWith('/new')) return <CreateRaceForm />;
    if (id && pathname.endsWith('/edit')) return <EditRaceForm raceId={id} />;
    if (id) return <RaceDetail raceId={id} />;
    return <RacesOverview />;
}
